import {EnvBankPutDataTransferObject} from "../../data-transfer-object/env/EnvBankPutDataTransferObject"
import {EnvBankValueObject} from "../../value-object/env/EnvBankValueObject"
import {StatePair, useStatePair} from "react-type-extension"
import {DateFormat} from "ts-format-extension"
import {unwrapUndefinedDate, unwrapUndefinedString} from "ts-type-extension"

export type EnvBankPutState = {
    name: StatePair<string>
    displayOrder: StatePair<number>
    toDataTransferObject(): EnvBankPutDataTransferObject
    fromValueObject(vo: EnvBankValueObject): void
    values(): [string, number]
}

export function useEnvBankPutState(): EnvBankPutState {
    return {
        name: useStatePair<string>(''),
        displayOrder: useStatePair<number>(0),
        toDataTransferObject(): EnvBankPutDataTransferObject {
            return {
                name: this.name.value,
                displayOrder: this.displayOrder.value,
            }
        },
        fromValueObject(vo: EnvBankValueObject) {
            this.name.setter(vo.name)
            this.displayOrder.setter(vo.displayOrder)
        },
        values(): [string, number] {
            return [
                this.name.value,
                this.displayOrder.value,
            ]
        }
    }
}
